import ThisModule from "./SimpleTable";

export default ThisModule;
